<template>
  <section class="customer-panel">
    <div class="customer-panel__content">
      <SupportBanner
        :title="$t('24小时在线客服')"
        :subtitle="$t('专业在线客服,贴心为您解决问题')" />

      <ul v-if="normalCustomerList.length" class="customer-panel__list">
        <li v-for="customer in normalCustomerList" :key="customer.id">
          <CustomerServiceItem
            :title="customer.title ?? ''"
            @select="handleCustomerClick(customer)" />
        </li>
      </ul>

      <p v-else-if="!isNormalCustomerListLoading" class="customer-panel__empty">
        {{ $t('暂无客服') }}
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import SupportBanner from './components/SupportBanner.vue'
import CustomerServiceItem from './components/CustomerServiceItem.vue'
import { useCustomerService } from '@/composables/useCustomerService'
import type { CustomerServiceDTO } from '@/types/service'
import dialog from '@/utils/dialog.ts'

// 普通客服列表
const { normalCustomerList, isNormalCustomerListLoading, fetchNormalCustomerList } =
  useCustomerService()

const handleCustomerClick = (customer: CustomerServiceDTO) => {
  if (!customer.chatUrl) return
  if (!/^https?:\/\//.test(customer.chatUrl)) {
    dialog.alert({
      content: `${customer.chatUrl} NOT A VALID URL`
    })
    return
  }
  window.open(customer.chatUrl, '_blank', 'noopener,noreferrer')
}

onMounted(() => {
  fetchNormalCustomerList()
})
</script>

<style scoped lang="scss">
.customer-panel {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  &__content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex: 1;
    min-height: 0;
    padding: 20px;
    overflow-y: auto;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  &__empty {
    margin: 0;
    padding: 20px 0;
    text-align: center;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
  }
}
</style>
